export const GET_COUPON_CODES_LIST = null;
export const SELECTED_COUPON_CODE_ID = null;